(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var breakpoint = window.matchMedia('(max-width: 749px)');

    function syncFooterGroups() {
      document.querySelectorAll('.yn-ft__group').forEach(function (group) {
        if (breakpoint.matches) {
          group.removeAttribute('open');
        } else {
          group.setAttribute('open', '');
        }
      });
    }

    syncFooterGroups();
    breakpoint.addEventListener('change', syncFooterGroups);
    document.addEventListener('shopify:section:load', syncFooterGroups);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yn-hero"]) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncHeroVideo = () => {
      document.querySelectorAll('.yn-home-hero__video').forEach((video) => {
        if (reduceMotion.matches) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });
    };

    syncHeroVideo();
    reduceMotion.addEventListener('change', syncHeroVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yn-home-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHomeFaq(root) {
      if (!root || root.dataset.ynHomeFaqReady === 'true') return;
      root.dataset.ynHomeFaqReady = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-yn-home-faq-item]'));

      async function animateItem(item, opening) {
        if (item.dataset.ynHomeFaqAnimating === 'true') return;
        var summary = item.querySelector('summary');
        var startHeight = item.offsetHeight;

        item.dataset.ynHomeFaqAnimating = 'true';
        item.style.overflow = 'hidden';
        if (opening) item.open = true;

        var endHeight = opening ? item.scrollHeight : summary.offsetHeight + 1;
        var animation = item.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 300, easing: 'ease-in-out' }
        );

        await animation.finished.catch(function () {});
        if (!opening) item.open = false;
        item.style.height = '';
        item.style.overflow = '';
        item.dataset.ynHomeFaqAnimating = 'false';
      }

      items.forEach(function (item) {
        item.querySelector('summary').addEventListener('click', async function (event) {
          event.preventDefault();
          if (root.dataset.ynHomeFaqTransitioning === 'true') return;

          var opening = !item.open;
          var openItems = items.filter(function (other) {
            return other !== item && other.open;
          });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            openItems.forEach(function (other) { other.open = false; });
            item.open = opening;
            return;
          }

          root.dataset.ynHomeFaqTransitioning = 'true';
          try {
            if (opening && openItems.length) {
              await Promise.all(openItems.map(function (other) {
                return animateItem(other, false);
              }));
            }
            await animateItem(item, opening);
          } finally {
            root.dataset.ynHomeFaqTransitioning = 'false';
          }
        });
      });
    }

    document.querySelectorAll('[data-yn-home-faq]').forEach(initHomeFaq);
    document.addEventListener('shopify:section:load', function (event) {
      initHomeFaq(event.target.querySelector('[data-yn-home-faq]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yn-modal-popup"]) return;
  try {
    
  (function () {
    var key = 'yn_popup';
    var dismissDuration = 7 * 24 * 60 * 60 * 1000;
    var overlay = document.getElementById('yn-popup-overlay');
    var popup = document.getElementById('yn-popup');
    var closeButton = document.getElementById('yn-popup-close');
    var dismissButton = document.getElementById('yn-popup-dismiss');
    var form = document.getElementById('yn-popup-form');
    var email = document.getElementById('yn-popup-email');
    var submitButton = document.getElementById('yn-popup-submit');
    var success = document.getElementById('yn-popup-success');
    var previousFocus = null;

    if (!overlay || !popup || !closeButton || !dismissButton || !form || !email || !submitButton || !success) return;

    function shouldShow() {
      try {
        var state = JSON.parse(localStorage.getItem(key) || '{}');
        if (state.subscribed) return false;
        if (state.dismissed && Date.now() - state.dismissed < dismissDuration) return false;
      } catch (error) {}
      return true;
    }

    function save(state) {
      try {
        localStorage.setItem(key, JSON.stringify(state));
      } catch (error) {}
    }

    function showPopup() {
      previousFocus = document.activeElement;
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          overlay.classList.add('yn-popup-visible');
          window.setTimeout(function () { email.focus(); }, 180);
        });
      });
    }

    function hidePopup(shouldDismiss) {
      overlay.classList.remove('yn-popup-visible');
      overlay.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        overlay.hidden = true;
        document.body.style.overflow = '';
        if (previousFocus && previousFocus.focus) previousFocus.focus();
      }, 360);
      if (shouldDismiss) save({ dismissed: Date.now() });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[href*="newsletter_jiYedU"]');
      if (!trigger) return;
      event.preventDefault();
      showPopup();
    });

    closeButton.addEventListener('click', function () { hidePopup(true); });
    dismissButton.addEventListener('click', function () { hidePopup(true); });

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) hidePopup(true);
    });

    document.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') {
        hidePopup(true);
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.slice.call(
        popup.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitButton.disabled = true;
      submitButton.firstChild.textContent = submitButton.dataset.loadingLabel + ' ';

      fetch(form.action, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function () {
        form.hidden = true;
        dismissButton.hidden = true;
        success.hidden = false;
        save({ subscribed: true });
        window.setTimeout(function () { hidePopup(false); }, 3500);
      }).catch(function () {
        submitButton.disabled = false;
        submitButton.firstChild.textContent = submitButton.dataset.label + ' ';
      });
    });

    if (shouldShow()) window.setTimeout(showPopup, 3000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuna-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArticle(root) {
      if (!root || root.dataset.ynArticleReady === 'true') return;
      root.dataset.ynArticleReady = 'true';

      var content = root.querySelector('[data-yn-article-content]');
      var toc = root.querySelector('[data-yn-toc]');
      var heroImage = root.querySelector('.yn-article-hero__media img');
      if (content && heroImage && content.firstElementChild) {
        var openingElement = content.firstElementChild;
        var openingImage = openingElement.matches('img') ? openingElement : openingElement.querySelector('img');
        if (openingImage) {
          var heroFile = new URL(heroImage.currentSrc || heroImage.src, window.location.href).pathname.split('/').pop();
          var openingFile = new URL(openingImage.currentSrc || openingImage.src, window.location.href).pathname.split('/').pop();
          var imageOnlyWrapper = openingElement.matches('img') || openingElement.textContent.trim() === '';
          if (heroFile === openingFile && imageOnlyWrapper) openingElement.remove();
        }
      }
      if (content && toc) {
        var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
        headings.forEach(function (heading, index) {
          if (!heading.id) heading.id = 'article-section-' + (index + 1);
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          toc.appendChild(link);
        });
        if (!headings.length) toc.closest('.yn-article-aside').hidden = true;
      }

      var shareButton = root.querySelector('[data-yn-share]');
      if (shareButton) {
        shareButton.addEventListener('click', function () {
          if (navigator.share) navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
          else navigator.clipboard.writeText(window.location.href).then(function () {
            shareButton.querySelector('span').textContent = 'Copied';
            window.setTimeout(function () { shareButton.querySelector('span').textContent = 'Share'; }, 1600);
          });
        });
      }

      var copyButton = root.querySelector('[data-yn-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', function () {
          navigator.clipboard.writeText(window.location.href).then(function () {
            copyButton.classList.add('is-copied');
            copyButton.setAttribute('aria-label', 'Link copied');
            window.setTimeout(function () { copyButton.classList.remove('is-copied'); }, 1600);
          });
        });
      }
    }

    document.querySelectorAll('[data-yn-article]').forEach(initArticle);
    document.addEventListener('shopify:section:load', function (event) {
      initArticle(event.target.querySelector('[data-yn-article]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuna-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DEFAULT_WHATSAPP_BASE = 'https://wa.me/918262050210';

    function getWhatsAppBase() {
      var link = document.querySelector('[data-yn-whatsapp]');
      if (link) {
        return link.getAttribute('data-yn-whatsapp-base') || link.getAttribute('href') || DEFAULT_WHATSAPP_BASE;
      }
      return DEFAULT_WHATSAPP_BASE;
    }

    function buildWhatsAppUrl(base, message) {
      if (!base) base = DEFAULT_WHATSAPP_BASE;
      try {
        var url = new URL(base, window.location.origin);
        if (message) url.searchParams.set('text', message);
        else url.searchParams.delete('text');
        return url.toString();
      } catch (e) {
        return base;
      }
    }

    function prefillContactForm(message) {
      if (!message) return false;
      var field = document.getElementById('YunaDoon-body');
      if (!field) return false;
      field.value = message;
      field.dispatchEvent(new Event('input', { bubbles: true }));
      field.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function syncWhatsAppChannelLink(message) {
      var links = document.querySelectorAll('[data-yn-whatsapp]');
      links.forEach(function (link) {
        var base = link.getAttribute('data-yn-whatsapp-base') || link.getAttribute('href') || DEFAULT_WHATSAPP_BASE;
        link.setAttribute('href', buildWhatsAppUrl(base, message));
      });
    }

    function openWhatsAppWithMessage(message) {
      prefillContactForm(message);
      syncWhatsAppChannelLink(message);
      try {
        sessionStorage.setItem('yn_pending_chat_message', message || '');
      } catch (e) {}

      var url = buildWhatsAppUrl(getWhatsAppBase(), message || 'Hi Yuna!');
      window.open(url, '_blank', 'noopener,noreferrer');
      return true;
    }

    function bindHelper(root) {
      if (!root || root.dataset.ynChatBound === 'true') return;
      root.dataset.ynChatBound = 'true';

      var form = root.querySelector('[data-yn-chat-search]');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var input = form.querySelector('input[type="search"], input[name="q"]');
          var message = input && input.value ? input.value.trim() : '';
          openWhatsAppWithMessage(message);
        });
      }
    }

    function bindEnquiryCard(card) {
      if (!card || card.dataset.ynEnquiryBound === 'true') return;
      card.dataset.ynEnquiryBound = 'true';
      card.addEventListener('click', function (event) {
        var form = document.getElementById('YunaDoonContactForm');
        if (!form) return;
        event.preventDefault();

        var subject = document.getElementById('YunaDoon-subject');
        var message = document.getElementById('YunaDoon-body');
        if (subject) {
          subject.value = 'Press, creators & partnerships';
          subject.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (message && !message.value.trim()) {
          message.value = (card.dataset.ynEnquiry || 'Business enquiry') + ':\n\n';
        }

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(function () {
          if (message) message.focus({ preventScroll: true });
        }, reduceMotion ? 0 : 450);
      });
    }

    function bindContactForm(form) {
      if (!form || form.dataset.ynSubmitBound === 'true') return;
      form.dataset.ynSubmitBound = 'true';
      form.addEventListener('submit', function () {
        if (!form.checkValidity()) return;
        var button = form.querySelector('.yn-doon__submit');
        if (!button) return;
        button.textContent = 'Sending...';
        button.setAttribute('aria-busy', 'true');
      });
    }

    function init() {
      document.documentElement.classList.add('yn-contact-page');
      document.querySelectorAll('[data-yn-chat-helper]').forEach(bindHelper);
      document.querySelectorAll('[data-yn-enquiry]').forEach(bindEnquiryCard);
      bindContactForm(document.getElementById('YunaDoonContactForm'));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-yn-chat-helper]').forEach(function (el) {
        el.dataset.ynChatBound = 'false';
      });
      document.querySelectorAll('[data-yn-enquiry]').forEach(function (el) {
        el.dataset.ynEnquiryBound = 'false';
      });
      var form = document.getElementById('YunaDoonContactForm');
      if (form) form.dataset.ynSubmitBound = 'false';
      init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuna-custom-orders"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCustomOrders(root) {
      if (!root || root.dataset.ynCustomReady === 'true') return;
      root.dataset.ynCustomReady = 'true';

      var form = root.querySelector('[data-yn-custom-form]');
      if (form) {
        form.addEventListener('submit', async function (event) {
          event.preventDefault();
          if (!form.reportValidity()) return;

          var data = new FormData(form);
          var submit = form.querySelector('[type="submit"]');
          var submitLabel = form.querySelector('[data-submit-label]');
          var status = form.querySelector('[data-form-status]');
          var endpoint = form.dataset.endpoint || '/apps/yuna-custom-orders/brief';
          var whatsappNumber = form.dataset.whatsapp || '918262050210';
          var submissionId = window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : 'brief-' + Date.now() + '-' + Math.random().toString(16).slice(2);
          var lines = [
            'Hi Yuna! I would like to create a custom nail set.',
            '',
            'Name: ' + data.get('name'),
            'Shape: ' + data.get('shape'),
            'Length: ' + data.get('length'),
            'Occasion: ' + data.get('occasion'),
            'Design direction: ' + data.get('direction'),
            'Budget: ' + data.get('budget')
          ];

          var details = String(data.get('details') || '').trim();
          if (details) lines.push('My idea: ' + details);
          if (data.get('reference')) lines.push('I have reference images to share.');
          lines.push('', 'Please help me refine the design, sizing, quote and timeline.');

          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          submitLabel.textContent = 'Saving your brief…';
          status.textContent = 'Creating your quote-pending draft in Shopify.';
          status.dataset.state = 'loading';

          var payload = {
            submissionId: submissionId,
            name: data.get('name'),
            email: data.get('email'),
            phone: data.get('phone'),
            shape: data.get('shape'),
            length: data.get('length'),
            occasion: data.get('occasion'),
            direction: data.get('direction'),
            budget: data.get('budget'),
            details: details,
            reference: Boolean(data.get('reference')),
            company: data.get('company')
          };

          try {
            var response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            });
            var result = await response.json().catch(function () { return {}; });
            if (!response.ok || !result.ok) throw new Error(result.error || 'Unable to save the brief.');

            if (result.draft && result.draft.name) {
              lines.splice(1, 0, 'Shopify brief: ' + result.draft.name);
            }
            status.textContent = 'Brief saved. Opening WhatsApp now.';
            status.dataset.state = 'success';
          } catch (error) {
            status.textContent = 'We could not save the Shopify draft right now. WhatsApp is opening so your enquiry is not lost.';
            status.dataset.state = 'error';
            lines.splice(1, 0, 'Note: the website could not save my brief automatically.');
          } finally {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
            submitLabel.textContent = 'Save brief & continue on WhatsApp';
            window.location.href = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(lines.join('\n'));
          }
        });
      }

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-yn-custom-accordion] details'));

      async function animate(item, opening) {
        var summary = item.querySelector('summary');
        var start = item.offsetHeight;
        item.style.overflow = 'hidden';
        if (opening) item.open = true;
        var end = opening ? item.scrollHeight : summary.offsetHeight + 1;
        var motion = item.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 300, easing: 'ease-in-out' });
        await motion.finished.catch(function () {});
        if (!opening) item.open = false;
        item.style.height = '';
        item.style.overflow = '';
      }

      items.forEach(function (item) {
        item.querySelector('summary').addEventListener('click', async function (event) {
          event.preventDefault();
          if (root.dataset.ynCustomTransitioning === 'true') return;
          var opening = !item.open;
          var openItem = items.find(function (other) { return other !== item && other.open; });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            items.forEach(function (other) { if (other !== item) other.open = false; });
            item.open = opening;
            return;
          }

          root.dataset.ynCustomTransitioning = 'true';
          if (opening && openItem) await animate(openItem, false);
          await animate(item, opening);
          root.dataset.ynCustomTransitioning = 'false';
        });
      });
    }

    // --- WhatsApp handoff for the native Shopify Forms app -----------------
    // The order form on this page is the native "Shopify Forms" app block
    // (<shopify-forms-embed>), which creates the real Shopify order/lead and
    // handles its own submission internally - this code does not touch that
    // flow. It only *listens* for a click on the app's submit button and
    // opens a WhatsApp chat pre-filled with what the customer typed.
    //
    // This is deliberately optimistic about speed: it does a brief check for
    // an immediate client-side validation error, then opens WhatsApp right
    // away rather than waiting for the Shopify Forms save (and its captcha
    // check) to fully finish - that real network round trip is the one delay
    // this code cannot shrink without skipping it. The trade-off, chosen
    // over a slower but fully-confirmed flow: in the rare case where the
    // save fails later in the background (a dropped connection, a Shopify
    // hiccup), WhatsApp still opens as if it succeeded.
    //
    // The app renders into an OPEN shadow root, so fields can be read and
    // clicks listened for from outside - no cross-origin iframe involved.
    // Its "Submit" button is a plain <button type="button">, not a real form
    // submit, so the app does its own fetch/AJAX call rather than a native
    // form post - a capture-phase click listener is used instead of a native
    // "submit" event so it is guaranteed to run as part of the same click.
    //
    // A tab is opened immediately (in the same click, before any validation
    // check even runs) because browsers only allow window.open() to bypass
    // the popup blocker when called synchronously inside a real user
    // gesture; waiting even briefly would risk it being silently blocked.
    // Instead of going anywhere yet, it shows a small branded "hang tight"
    // screen for the ~150ms it takes to rule out an instant validation
    // error, then either gets pointed at wa.me or is closed if that
    // validation error appeared.
    //
    // Respecting the real form's validation: none of the fields carry a
    // native `required` attribute - the app validates on submit and shows
    // its own error state, so `form.checkValidity()` cannot be used. Instead,
    // right after the click there is a brief 150ms check for a visible
    // error/alert appearing in the form (near-instant client-side rejections
    // show up well inside that window). If one appears, the waiting tab is
    // closed and WhatsApp never opens. Otherwise, WhatsApp opens - without
    // waiting any further for the save itself to be confirmed.
    //
    // Field values are matched by their visible label text, not fragile
    // generated field IDs, so this keeps working if fields are reordered.

    function ynWaFieldValueByLabel(root, matcher) {
      var candidates = Array.prototype.slice.call(root.querySelectorAll('input, textarea'));
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var label = '';
        if (el.id) {
          var lab = root.querySelector('label[for="' + el.id + '"]');
          if (lab) label = lab.textContent || '';
        }
        if (!label && el.closest) {
          var closestLabel = el.closest('label');
          if (closestLabel) label = closestLabel.textContent || '';
        }
        if (!label) label = el.getAttribute('aria-label') || el.placeholder || '';
        if (label && matcher.test(label)) return (el.value || '').trim();
      }
      return '';
    }

    function ynWaHasVisibleError(root) {
      if (root.querySelector('[aria-invalid="true"]')) return true;
      if (root.querySelector('[role="alert"]')) return true;
      var errorish = root.querySelectorAll('[class*="rror"], [class*="rror" i], [data-invalid="true"], [data-error="true"]');
      for (var i = 0; i < errorish.length; i++) {
        if ((errorish[i].textContent || '').trim()) return true;
      }
      return false;
    }

    function ynWaIsBusy(button) {
      return !!(button.disabled || button.getAttribute('aria-busy') === 'true' || button.getAttribute('aria-disabled') === 'true');
    }

    function ynWaPaintWaitingScreen(win) {
      try {
        win.document.open();
        win.document.write(
          '<!doctype html><html><head><meta charset="utf-8">' +
          '<title>Yuna Nails</title>' +
          '<style>' +
          'html,body{height:100%;margin:0}' +
          'body{display:flex;align-items:center;justify-content:center;background:#3D0B0E;' +
          'font-family:Georgia,\'Darrell Rolando\',serif;color:#F4EAE0;text-align:center;padding:24px;box-sizing:border-box}' +
          '.yn-wait__mark{font-style:italic;font-size:clamp(1.6rem,4vw,2.4rem);margin:0 0 12px}' +
          '.yn-wait__sub{font-family:Arial,sans-serif;font-size:13px;letter-spacing:.02em;color:#F4EAE0;margin:0}' +
          '</style></head><body>' +
          '<div><p class="yn-wait__mark">Confirming your brief&hellip;</p>' +
          '<p class="yn-wait__sub">WhatsApp will open here in a moment.</p></div>' +
          '</body></html>'
        );
        win.document.close();
      } catch (e) {}
    }

    function ynWaAttachHandler(wrapper, root, form) {
      var whatsappNumber = (wrapper.dataset.whatsapp || '918262050210').replace(/[^0-9]/g, '');

      form.addEventListener('click', function (event) {
        var button = event.target && event.target.closest
          ? event.target.closest('button[class*="_formSubmitButton_"], button[type="submit"]')
          : null;
        if (!button) return;
        if (form.dataset.ynWaHandled === 'true') return;
        form.dataset.ynWaHandled = 'true';

        // Opened now (required to dodge the popup blocker) but shows a
        // waiting screen, not WhatsApp, until the real submission is confirmed.
        var waWin = null;
        try { waWin = window.open('', '_blank'); } catch (e) {}
        if (waWin) ynWaPaintWaitingScreen(waWin);

        var name = ynWaFieldValueByLabel(root, /first ?name|^name$|full ?name/i);
        var email = ynWaFieldValueByLabel(root, /email/i);
        var phone = ynWaFieldValueByLabel(root, /whatsapp|phone/i);
        var instagram = ynWaFieldValueByLabel(root, /instagram/i);
        var idea = ynWaFieldValueByLabel(root, /inspiration|idea|describe|details/i);

        var lines = ['Hi Yuna! I just submitted my custom order brief on your website.', ''];
        if (name) lines.push('Name: ' + name);
        if (phone) lines.push('WhatsApp: ' + phone);
        if (email) lines.push('Email: ' + email);
        if (instagram) lines.push('Instagram: ' + instagram);
        if (idea) lines.push('My idea: ' + idea);
        lines.push('', 'Please help me refine the design, sizing, quote and timeline.');

        var waUrl = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(lines.join('\n'));
        var settled = false;

        function cancel() {
          if (settled) return;
          settled = true;
          if (waWin && !waWin.closed) waWin.close();
          form.dataset.ynWaHandled = 'false';
        }

        function proceed() {
          if (settled) return;
          settled = true;
          if (waWin && !waWin.closed) waWin.location.href = waUrl;
          setTimeout(function () { form.dataset.ynWaHandled = 'false'; }, 1500);
        }

        // Optimistic handoff - most client-side validation errors (a required
        // field left blank, etc.) render near-instantly with no network call
        // involved, so a brief 150ms check catches them. Once that short
        // window passes with no visible error, WhatsApp opens right away -
        // it does not wait for the Shopify Forms save (plus its captcha
        // check) to fully finish first, since that round trip is the one
        // delay this code cannot shrink without skipping it. In the rare
        // case where the save fails later in the background, WhatsApp still
        // opens as if it succeeded.
        var fastCheckElapsed = 0;
        var fastCheckWindow = 150;
        var pollEvery = 20;

        var fastCheckTimer = setInterval(function () {
          fastCheckElapsed += pollEvery;
          if (settled) {
            clearInterval(fastCheckTimer);
            return;
          }
          if (ynWaHasVisibleError(root)) {
            clearInterval(fastCheckTimer);
            cancel();
            return;
          }
          if (fastCheckElapsed >= fastCheckWindow) {
            clearInterval(fastCheckTimer);
            proceed();
          }
        }, pollEvery);
      }, true);
    }

    function ynWaTryAttach(wrapper, attemptsLeft) {
      if (wrapper.dataset.ynWaReady === 'true') return;
      var host = wrapper.querySelector('shopify-forms-embed');
      var root = host && host.shadowRoot;
      var form = root && root.querySelector('form');
      if (!form) {
        if (attemptsLeft > 0) setTimeout(function () { ynWaTryAttach(wrapper, attemptsLeft - 1); }, 250);
        return;
      }
      wrapper.dataset.ynWaReady = 'true';
      ynWaAttachHandler(wrapper, root, form);
    }

    function ynWaScan() {
      document.querySelectorAll('.yn-custom__form--shopify[data-whatsapp]').forEach(function (wrapper) {
        ynWaTryAttach(wrapper, 40);
      });
    }

    document.querySelectorAll('[data-yn-custom-orders]').forEach(initCustomOrders);
    document.addEventListener('shopify:section:load', function (event) {
      initCustomOrders(event.target.querySelector('[data-yn-custom-orders]'));
      var wrapper = event.target.querySelector('.yn-custom__form--shopify[data-whatsapp]');
      if (wrapper) ynWaTryAttach(wrapper, 40);
    });

    ynWaScan();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuna-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var labels = {
      product: 'Product & fit',
      application: 'Application & wear',
      removal: 'Removal & reuse',
      orders: 'Orders & delivery',
      payments: 'Payments & offers',
      returns: 'Returns & custom'
    };

    function initFaq(root) {
      if (!root || root.dataset.ynFaqReady === 'true') return;
      root.dataset.ynFaqReady = 'true';

      var form = root.querySelector('[data-yn-faq-search]');
      var input = root.querySelector('[data-yn-faq-input]');
      var clear = root.querySelector('[data-yn-faq-clear]');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-yn-faq-tab]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-yn-faq-item]'));
      var heading = root.querySelector('[data-yn-faq-heading]');
      var status = root.querySelector('[data-yn-faq-status]');
      var empty = root.querySelector('[data-yn-faq-empty]');
      var resultsHead = root.querySelector('.yn-faq__results-head');
      var active = 'product';

      async function animateItem(item, isOpening) {
        if (item.dataset.ynFaqAnimating === 'true') return;

        var summary = item.querySelector('summary');
        var startHeight = item.offsetHeight;
        var endHeight;

        item.dataset.ynFaqAnimating = 'true';
        item.style.overflow = 'hidden';

        if (isOpening) {
          item.open = true;
          endHeight = item.scrollHeight;
        } else {
          endHeight = summary.offsetHeight + 1;
        }

        var animation = item.animate(
          [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
          { duration: 300, easing: 'ease-in-out' }
        );

        await new Promise(function (resolve) {
          window.setTimeout(resolve, 300);
        });
        animation.cancel();

        if (!isOpening) item.open = false;
        item.style.height = '';
        item.style.overflow = '';
        item.dataset.ynFaqAnimating = 'false';
      }

      items.forEach(function (item) {
        var summary = item.querySelector('summary');

        summary.addEventListener('click', async function (event) {
          event.preventDefault();
          if (root.dataset.ynFaqTransitioning === 'true') return;

          var isOpening = !item.open;
          var openItems = items.filter(function (other) {
            return other !== item && other.open;
          });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            openItems.forEach(function (other) { other.open = false; });
            item.open = isOpening;
            return;
          }

          root.dataset.ynFaqTransitioning = 'true';
          try {
            if (isOpening && openItems.length) {
              await Promise.all(openItems.map(function (other) {
                return animateItem(other, false);
              }));
            }

            await animateItem(item, isOpening);
          } finally {
            root.dataset.ynFaqTransitioning = 'false';
          }
        });
      });

      function render() {
        var query = input.value.trim().toLowerCase();
        var terms = query.split(/\s+/).filter(Boolean);
        var visible = 0;

        items.forEach(function (item) {
          var show = query
            ? terms.every(function (term) { return item.dataset.search.indexOf(term) !== -1; })
            : item.dataset.category === active;
          item.hidden = !show;
          if (!show) item.removeAttribute('open');
          if (show) visible += 1;
        });

        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', String(!query && tab.dataset.ynFaqTab === active));
        });
        heading.textContent = query ? 'Search results' : labels[active];
        status.textContent = visible + (visible === 1 ? ' answer' : ' answers');
        clear.hidden = !query;
        empty.hidden = visible !== 0;
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          active = tab.dataset.ynFaqTab;
          input.value = '';
          render();
          root.querySelector('.yn-faq__results-head').scrollIntoView({ block: 'nearest' });
        });
      });

      input.addEventListener('input', render);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        render();
        resultsHead.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
      clear.addEventListener('click', function () {
        input.value = '';
        input.focus();
        render();
      });

      render();
    }

    function initAllFaqs() {
      document.querySelectorAll('[data-yn-faq]').forEach(initFaq);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllFaqs);
    } else {
      initAllFaqs();
    }
    document.addEventListener('shopify:section:load', initAllFaqs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuna-tutorials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTutorials(root) {
      if (!root || root.dataset.ynTutorialsReady === 'true') return;
      root.dataset.ynTutorialsReady = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-yn-tutorial-accordion] details'));

      async function animate(item, opening) {
        var summary = item.querySelector('summary');
        var start = item.offsetHeight;
        var end;

        item.style.overflow = 'hidden';
        if (opening) {
          item.open = true;
          end = item.scrollHeight;
        } else {
          end = summary.offsetHeight + 1;
        }

        var motion = item.animate(
          [{ height: start + 'px' }, { height: end + 'px' }],
          { duration: 300, easing: 'ease-in-out' }
        );

        await motion.finished.catch(function () {});
        if (!opening) item.open = false;
        item.style.height = '';
        item.style.overflow = '';
      }

      items.forEach(function (item) {
        item.querySelector('summary').addEventListener('click', async function (event) {
          event.preventDefault();
          if (root.dataset.ynTutorialsTransitioning === 'true') return;

          var opening = !item.open;
          var others = items.filter(function (other) { return other !== item && other.open; });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            others.forEach(function (other) { other.open = false; });
            item.open = opening;
            return;
          }

          root.dataset.ynTutorialsTransitioning = 'true';
          try {
            if (opening && others.length) {
              await Promise.all(others.map(function (other) { return animate(other, false); }));
            }
            await animate(item, opening);
          } finally {
            root.dataset.ynTutorialsTransitioning = 'false';
          }
        });
      });
    }

    function initAllTutorials() {
      document.querySelectorAll('[data-yn-tutorials]').forEach(initTutorials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllTutorials);
    } else {
      initAllTutorials();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initTutorials(event.target.querySelector('[data-yn-tutorials]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
